module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crowdfunding-camapaign"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "crowd-or-rais"
  }, [_c('router-link', {
    staticClass: "domore-blue-1",
    attrs: {
      "to": "/crowdfunding"
    }
  }, [_vm._v("CROWDFUNDING")]), _vm._v(" "), _c('span', {
    staticClass: "or"
  }, [_vm._v("/")]), _vm._v(" "), _c('router-link', {
    staticClass: "rais-or",
    attrs: {
      "to": "/fundraising"
    }
  }, [_vm._v("FUNDRAISING")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "big-slogan-blue mb-30"
  }, [_vm._v(_vm._s(_vm.$t("project.slogan")))]), _vm._v(" "), (_vm.isFinished) ? _c('h2', {
    staticClass: "short-desc"
  }, [_vm._v(_vm._s(_vm.$t('project.finished')))]) : _vm._e()]), _vm._v(" "), _c('basics', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container campaign-details crowd"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('project-details', {
    attrs: {
      "project": _vm.project
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "all-categories mb-20"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("rewards")))])]), _vm._v(" "), _vm._l((_vm.rewards), function(reward) {
    return (_vm.project.id) ? _c('reward', {
      key: reward.id,
      attrs: {
        "reward": reward,
        "project": _vm.project
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.rewards.length) ? _c('p', {
    staticClass: "center"
  }, [_vm._v(_vm._s(_vm.$t('project.hasNoRewards')))]) : _vm._e()], 2)]), _vm._v(" "), _c('verify-project', {
    staticClass: "mt-50",
    attrs: {
      "project": _vm.project
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container mb-30"
  }, [_c('div', {
    staticClass: "all-categories mb-20"
  }, [_c('strong', [_vm._v("CROWDFUNDING: ")]), _vm._v(_vm._s(_vm.$t("project.show.otherCampaigns")) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.projects), function(project) {
    return _c('crowdfunding-tile', {
      key: project.id,
      attrs: {
        "project": project,
        "size": "col-md-6"
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "container mb-30"
  }, [_c('div', {
    staticClass: "all-categories"
  }, [_c('strong', [_vm._v("CROWDFUNDING:")]), _vm._v(_vm._s(_vm.$t("project.allCategories")) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "all-categories-list-crowd"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.categories), function(category, i) {
    return _c('li', {
      key: i
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/crowdfunding',
          query: {
            category: category.name
          }
        }
      }
    }, [_vm._v(_vm._s(category.name))])], 1)
  }), 0)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mt-50 mb-50"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/img/star.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cccb614"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Crowdfunding/Show.vue
// module id = 814
// module chunks = 1